import { useEffect, useState } from "react";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { ParametroEmpresa } from "../../models/administracion/ParametroEmpresa";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";

export const ConfiguracionEmpresa = ({ id, permss, generic, setDialog, toast }) => {

    const procesoSrv = new MonitoreoService();
    const omodel = new ParametroEmpresa();
    const defaultValues = generic.default(omodel.model, null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [catalogos, setCatalogos] = useState(null);
    const [siEstado, setSiEstado] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inDrop, inDropMultiple } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [loadingProceso, setLoadingProceso] = useState(false);

    useEffect(() => {
        consultar(0);
    }, [id]);

    const consultar = () => {
        const inicio = catalogos ? 0 : 1;
        procesoSrv.consultar(`${id}/${inicio}`, 'admin-config-empresa/consulta').then(res => {
            const data = (res.data.configuracion)[0];
            if (inicio === 1) {
                setCatalogos(res.data.catalogos);
            }
            setSiEstado(data?.estado === true);
            data.estado = generic.sino.find((itm) => itm.cat_id === data.estado);
            data.periocidad = res.data?.periocidad ?? [];
            reset(generic.renewValues(data, omodel.model));
        });
    };

    const onSubmit = (data) => {
        data.empresa = id;
        data.index = activeIndex;
        procesoSrv.editar(data, 'admin-config-empresa/editar').then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const onChangeEstado = (e) => {
        setSiEstado(e.value?.cat_id === true);
    }

    const ejecutarProcesoHistorico = () => {
        if (!fechaInicio || !fechaFin) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Debe seleccionar el rango de fechas completo' });
            return;
        }
        const payload = {
            empresa_id: id,
            fecha_inicio: generic.dateToString(fechaInicio),
            fecha_fin: generic.dateToString(fechaFin)
        };

        setLoadingProceso(true);
        procesoSrv.nuevo(payload, 'admin-config-empresa/procesar/alertas').then(res => {
            generic.funcSuccess(res, toast);
            setLoadingProceso(false);
            setFechaInicio(null);
            setFechaFin(null);
        }).catch(error => {
            generic.funcError(error, toast);
            setLoadingProceso(false);
        });
    }

    return (
        <>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <AccordionTab header="Activar procesos">
                        <div className="formgrid grid">
                            {inDrop('estado', generic?.sino, { lab: omodel.optionLabel, chn: onChangeEstado }, 3)}
                            {siEstado && inDropMultiple('periocidad', catalogos?.periocidad, { lab: omodel.optionLabel }, 9)}
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Procesar Alertas Históricas">
                        <div className="formgrid grid">
                            <div className="col-12 mb-2">
                                <small>Este proceso verificará y generará las alertas en el periodo seleccionado.</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="f_inicio" style={{ fontWeight: 'bold', display: 'block' }}>Fecha Inicio</label>
                                <Calendar id="f_inicio" value={fechaInicio} onChange={(e) => setFechaInicio(e.value)} showIcon placeholder="Seleccione fecha" dateFormat="dd/mm/yy" maxDate={new Date()} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="f_fin" style={{ fontWeight: 'bold', display: 'block' }}>Fecha Fin</label>
                                <Calendar id="f_fin" value={fechaFin} onChange={(e) => setFechaFin(e.value)} showIcon placeholder="Seleccione fecha" dateFormat="dd/mm/yy" maxDate={new Date()} minDate={fechaInicio} />
                            </div>
                            <div className="col-12 md:col-4 flex align-items-end pb-3">
                                <Button type="button" label="Ejecutar Proceso" icon="pi pi-bolt" className="p-button-warning w-full" onClick={ejecutarProcesoHistorico} loading={loadingProceso} disabled={!fechaInicio || !fechaFin} />
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
                <br />
                {generic.buttonsForms(setDialog)}
            </form>
        </>
    )
}
